import React from 'react';
import { Box, IBoxProps } from '@styleseat/ui';

export type LineClampProps = Omit<IBoxProps, 'overflow' | 'display'> & {
  clamp: number;
};

const LineClamp: React.FC<LineClampProps> = ({
  children,
  clamp,
}) => (
  <Box
    // -webkit-box is invalid for dipslay
    // @ts-expect-error Grandfathered
    style={{
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: clamp,
    }}
  >
    {children}
  </Box>
);

export default LineClamp;
